import React from 'react';
import { Typography, Box, Stack } from '@mui/material';
import { authApi } from '../../api/auth';
import PageLayout from '../../components/layout/PageLayout';
import { useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import * as yup from 'yup';
import BasicButton from '../../components/button/BasicButton';
import theme from '../../theme';
import CustomTextField from '../../components/common/CustomTextField';
import SuccessfulSubmitEmail from './components/SuccessfulSubmitEmail';

const schema = yup.object().shape({
  email: yup
    .string()
    .email('올바른 이메일 형식을 입력해 주세요.')
    .required('이메일을 입력해 주세요.'),
});

const PasswordForgot = () => {
  const {
    register,
    handleSubmit,
    setError,
    formState: { errors, isSubmitting, isSubmitSuccessful },
  } = useForm({
    resolver: yupResolver(schema),
    defaultValues: {
      email: '',
    },
  });

  const onSubmit = async (formData) => {
    try {
      const response = await authApi.checkEmailStatus(formData.email);
      if (response.data.status !== 'DUPLICATED') {
        setError('email', {
          type: 'manual',
          message: '가입한 이력이 없습니다.',
        });
        return;
      }
      // 백그라운드에서 이메일 전송 (응답을 기다리지 않음)
      authApi.sendPasswordResetEmail(formData.email).catch((err) => {
        console.error('이메일 전송 실패:', err);
      });
    } catch (err) {
      console.error(err);
    }
  };

  return (
    <PageLayout>
      <Box
        sx={{
          width: '100%',
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
        }}
      >
        {isSubmitSuccessful ? (
          <SuccessfulSubmitEmail />
        ) : (
          <Box
            sx={{
              width: { lg: '32.5%', md: '49%', xs: '100%' },
              minWidth: { xs: '320px' },
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
            }}
          >
            <Stack sx={{ width: '100%' }} spacing={'40px'}>
              <Stack spacing={'16px'}>
                <Typography
                  fontSize={{ lg: 24, md: 22, xs: 20 }}
                  fontWeight="bold"
                  textAlign="center"
                >
                  비밀번호 재설정
                </Typography>
                <Typography
                  fontSize="14px"
                  textAlign="center"
                  color={theme.palette.black[4]}
                  align="center"
                  sx={{
                    whiteSpace: 'pre-line',
                    display: 'block',
                  }}
                >
                  <Box sx={{ display: { lg: 'block', md: 'none', xs: 'none', lineHeight: 1.5 } }}>
                    가입하신 이메일 주소를 입력하시면 비밀번호 재설정 링크를 {'\n'}보내드립니다.
                  </Box>
                  <Box sx={{ display: { lg: 'none', md: 'block', xs: 'block', lineHeight: 1.5 } }}>
                    가입하신 이메일 주소를 입력하시면{'\n'}비밀번호 재설정 링크를 보내드립니다.
                  </Box>
                </Typography>
              </Stack>

              <Stack>
                <Stack spacing={1}>
                  <Typography variant="body3">
                    이메일<span style={{ color: theme.palette.secondary.main }}>*</span>
                  </Typography>
                  <CustomTextField
                    fullWidth
                    {...register('email')}
                    error={!!errors.email}
                    helperText={errors.email?.message}
                  />
                </Stack>
              </Stack>
            </Stack>

            <Box sx={{ width: '100%' }} mt={'30px'}>
              <BasicButton
                type="submit"
                fullWidth
                disabled={isSubmitting}
                onClick={handleSubmit(onSubmit)}
              >
                제출
              </BasicButton>
            </Box>
          </Box>
        )}
      </Box>
    </PageLayout>
  );
};

export default PasswordForgot;
